import { notifications } from "@mantine/notifications"
import i18next from "i18next"

type Props = {
  message?: string
  title?: string
}

export const showErrorNotification = ({ message, title }: Props = {}) => {
  notifications.show({
    title: title ?? i18next.t("error.title"),
    message: message ?? i18next.t("error.message"),
    color: "var(--mantine-color-error)",
  })
}
